<template>
	<div class="post-status">
        <div class="publish-status">
            <span class="publish-status__indicator" :data-state="postStatus"></span>
            {{ postStatusText }}
        </div>
	</div>
</template>

<script>
    import { format, parse} from 'date-fns';
	export default {
		name: 'ColumnPostStatus',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
        computed: {
            // Sets the class for the post status indicator/light
            postStatus: function() {
                if( this.rowData.status === 0 ){
                    return 'unsaved';
                }

                if( this.rowData.status === 1 ){
                    return 'draft';
                }

                return 'published'
            },
            // Sets the text for the post status indicator
            postStatusText: function() {
                if( this.rowData.status === 0 ){
                    return 'Un-Saved';
                }

                if( this.rowData.status === 1 ){
                    return 'Draft';
                }

                if( this.rowData.published_at === 1 ){
                    return 'Draft';
                }

                return 'Published';
            },
        },
		data () {
            return {}
        },
	}
</script>
